import * as React from 'react'

function RightLineIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={31.987} height={18.002} viewBox="0 0 31.987 18.002" {...props}>
      <path
        data-name="arrow 4 click"
        d="M0 9l9.174-9v4.384L6.043 7.457h25.943v3H5.956l3.219 3.157V18z"
        transform="rotate(180 15.993 9)"
        fill="CurrentColor"
      />
    </svg>
  )
}

export default RightLineIcon
